import React from 'react';
import styles from '../styles/button.module.scss'

function Button(props) {
    return (
      <a role="button" onClick={props.onClick} className={styles.button} href={props.href} style={{backgroundColor: props.backgroundColor, fontSize: props.fontSize, outlineColor: props.outlineColor}} target={props.target}>
        <span className={styles.label}>{props.label}</span>
        <span className={styles.price}>${props.price}/<span className={styles.month}>{props.length}</span></span>
      </a>
    )
}

export default Button